export const applicationEndpoints = {
  users: 'users',
  all: 'users/all',
  usersToImpersonate: 'users/to-impersonate',
  impersonateUser: 'oauth2/impersonate/:userId',
  retrieveTranslations: 'lokalise/retrieveTranslationFiles',
  getRoleByCode: 'roles/get-by-code',
};
